// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__LiueZ","body":"style__body__DQt4b","header":"style__header__3UzqF","footer":"style__footer__dVUWe"};